export default {
  name: '知识比拼',
  path: '/fkc',
  redirect: '/fkc/admin',
  component: () => import('@/views/layout/index.vue'),
  children: [
    {
      name: '领队菜单',
      path: '/fkc/leader',
      redirect: '/fkc/leader/pre-results',
      children: [
        {
          name: '初赛信息查询',
          path: '/fkc/leader/pre-results',
          component: () => import('@/views/manage-fkc/leader/pre-results/index.vue'),
        },
        {
          name: '决赛信息查询',
          path: '/fkc/leader/final-results',
          component: () => import('@/views/manage-fkc/leader/final-results/index.vue'),
        },
        {
          name: '获奖名单查询',
          path: '/fkc/leader/final-rewards',
          component: () => import('@/views/manage-fkc/leader/final-rewards/index.vue'),
        },
        {
          name: '电子证书下载-fkc',
          path: '/fkc/leader/certificate',
          component: () => import('@/components/certificate/index.vue'),
        },
      ],
    },
    {
      name: '管理员菜单',
      path: '/fkc/admin',
      redirect: '/fkc/admin/pre-results',
      children: [
        {
          name: '初赛信息查询',
          path: '/fkc/admin/pre-results',
          component: () => import('@/views/manage-fkc/admin/pre-results/index.vue'),
        },
        {
          name: '决赛信息查询',
          path: '/fkc/admin/final-results',
          component: () => import('@/views/manage-fkc/admin/final-results/index.vue'),
        },
        {
          name: '获奖名单查询',
          path: '/fkc/admin/final-rewards',
          component: () => import('@/views/manage-fkc/admin/final-rewards/index.vue'),
        },
      ],
    },
  ],
};
